export const translationPath = 'chatBot.page.register.ticketServiceTypebot.';

export const applyTranslations = (field: string): string => {
    return `${translationPath}${field}`;
}